import React from 'react';
import Loading from './Loading';

const Ticket = ({col, variant, title, body, icon, loading}) => {
    if (!col || !(typeof col == 'number') ||  col < 1 || col > 12){ col = 3 }
    if (!variant && variant !== 'success' && variant !== 'info' && variant !== 'warning' && variant !== 'dark' && variant !== 'danger' && variant !== 'secondary') {variant = 'primary'}
    if (!loading) {loading=false;}
    return ( 
        <div className={`col-xl-${col} col-md-6 mb-4`}>
            <div className={`card border-left-${variant} shadow h-100 py-2`}>
                <div className="card-body">
                    {loading ? <Loading/>:
                        <div className="row no-gutters align-items-center">
                            <div className="col mr-2">
                                <div className={`text-xs font-weight-bold text-${variant} text-uppercase mb-1`}>
                                    {title}
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-gray-800">{body}</div>
                            </div>
                            <div className="col-auto">
                                <i className="fas fa-calendar fa-2x text-gray-300">{icon}</i>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
     );
}
 
export default Ticket;